<template>
    <v-layout align-start>
        <v-flex>
             <v-data-table
                :headers="headers"
                :items="enlaceUsuarios"
                :search="search"
                :expanded.sync="expanded"
                :single-expand="true"                
                class="elevation-1"
                :loading="loading"
                :options.sync="options"
                :server-items-length="totalItems"
                >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Enlace Usuario</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>

                    <v-text-field class="text-xs-center" 
                        v-model="search" 
                        append-icon="search" 
                     
                       @click:append="GetEnlaceUsuario"
                        @keyup.enter="GetEnlaceUsuario"
                        label="Busqueda" 
                        single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <!-- ********** -->
                    <v-dialog v-model="dialog" fullscreen 
                        hide-overlay transition="dialog-bottom-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on" 
                                @click="newItem"
                                outlined>Asigna enlaces a usuario</v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title>
                                    <span class="headline">
                                        Asigna enlaces a grupos
                                    </span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn dark text @click="newItem">Limpiar Controles</v-btn>
                                <v-toolbar-items>
                                </v-toolbar-items>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn 
                                       @click="saveItem"
                                        dark text>
                                        Grabar
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-list three-line subheader>
                                <v-container fluid>
                                    <v-row>
                                      
                                        <v-col cols="12" sm="12" md="6">
                                            <v-autocomplete
                                                v-model="editedItem.idGrupo"
                                                :items="catGrupos"
                                                :filter="customFilterGrupo"
                                                color="white"
                                                item-text="nombre"
                                                item-value="idGrupo"
                                                label="Grupo"
                                                multiple
                                            ></v-autocomplete>
                                        </v-col>
                                       
                                        <v-col cols="12" lg="4">
                                            <v-autocomplete
                                                v-model="editedItem.idEnlace"
                                                :items="catEnlace"
                                               :filter="customFilterCom"
                                                color="white"
                                                item-text="descripcion"
                                                item-value="idEnlace"
                                                label="Enlace"
                                            ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list>
                        </v-card>
                        <v-divider></v-divider>
                    </v-dialog>
                    <!-- ********** -->
                    </v-toolbar>
                </template>


                <!-- GRID PRINCIPAL -->
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td>
                               <div>

                                   <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on">
                                            <v-icon small class="mr-2" @click="deleteItem(item)">
                                              delete
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                              </div>
                            </td>
                            <td>{{ item.idEnlaceUsuario }}</td>
                            <td> {{ item.nombre }}</td>
                            <td>{{ item.descripcion }}</td>
                            <td>{{ item.url }}</td>
                            <td>{{ item.fechaInicio }}</td>
                            <td>{{ item.fechaFin }}</td>
                            <td>
                                <v-icon class="mr-2">
                                    {{ item.vigencia ? 'done_outline' : 'highlight_off' }}
                                </v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">More info about {{ item.name }}</td>
                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Resetear</v-btn>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import moment from 'moment'
export default {
    name: 'enlaceusuario',
    components: {
    },
    data () {
        return {
            enlaceUsuarios:[],
            catGrupos: [],
            catEnlace: [],
            expanded: [],

            editedItem: {},
            dialogFecha: false,

            vShowTipo: {},
            vDialogTipo: false,
            
            options: {},
            totalItems: 1000,
            page: 1,
            pageCount: 0,
            loading: false,
            consultaDto: {
                Skip: 0,
                Take: 10,
                descending: true,
                sortBy: '',
                search: '',
                extraParam: '3'
            },
            consultaDtoUser: {
                Skip: 0,
                Take: 100,
                descending: true,
                sortBy: '',
                search: ''
            },

            dialog: false,
            headers: [
                { text: 'Opciones', value: ' ' },
                { text: 'IdEnlaceUsuario', value: 'idEnlaceUsuario' },
                { text: 'Nombre', value: 'nombre' },
                { text: 'Descripcion', value: 'descripcion' },
                { text: 'Url', value: 'url' },
                { text: 'Fecha Inicio', value: 'FechaInicio' },
                { text: 'Fecha Fin', value: 'FechaFin' },
                { text: 'Vigencia', value: 'vigencia' },
            ],
            rulesIMG: [
                value => !value || value.size < 2000000 || 'La imagen no puede ser mayor de 2 MB!',
            ],
            rulesPDF: [
                value => !value || value.size < 2000000 || 'El PDF no puede ser mayor de 2 MB!',
            ],
            files: null,
            search: '',
        }
    },
    computed: { },
    watch: {
        options: {
            handler () {
                this.GetEnlaceUsuario()
                    // .then(data => {
                    //     this.desserts = data.items
                    //     this.totalDesserts = data.total
                    // })
            },
            deep: true
        }
    },
    created () { },
    mounted () {
        this.Default()
    },
    filters: {
        formatDate (date) {
            return moment(date).format('L')
        }
    },
    methods: {
        Default () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.GetEnlaceUsuario()
            
            me.$axios.get('api/Grupos/Get')
                .then(r => {
                    if (r.data.exito) {
                        me.catGrupos = r.data.datos
                    }
                })
                .catch(e => { console.log(e) })

            me.$axios.get('api/Enlace/Get')
                .then(r => {
                    me.catEnlace = r.data.datos
                })
                .catch(e => { console.log(e) })
        },
        customFilterGrupo (item, queryText, itemText) {
            const textOne = item.nombre.toLowerCase()
            const searchText = queryText.toLowerCase()
            let r = textOne.indexOf(searchText) > -1 
            return r
        },
        customFilterCom (item, queryText, itemText) {
            const textOne = item.descripcion.toLowerCase()
            const searchText = queryText.toLowerCase()
            let r = textOne.indexOf(searchText) > -1 
            return r
        },
        newItem () {
            let me = this
            me.$axios.get('api/EnlaceUsuario/New')
                .then(r => {
                    me.editedItem = r.data
                })
                .catch(e => { console.log(e) })
        },
        GetEnlaceUsuario () {
            var me = this
            const { sortBy, sortDesc, page, itemsPerPage } = this.options
            var skip = (page - 1) * itemsPerPage
            console.log(skip)
            debugger
            this.loading = true
            me.consultaDto.Skip = skip
            me.consultaDto.Take = itemsPerPage
            me.consultaDto.search = me.search
            me.$axios.post('api/EnlaceUsuario/Get', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.totalItems = r.data.integer
                        var tempCat = r.data.datos
                        me.enlaceUsuarios = []
                        for (var i = 0; i < tempCat.length; i++) {
                            var item = tempCat[i]
                            item.fechaInicio = moment(item.fechaInicio).format('L')
                            item.fechaFin = moment(item.fechaFin).format('L')                            
                            me.enlaceUsuarios.push(item)
                        }
                  
                    }
                    me.$root.Mensaje(r.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                    this.loading = false
                })
                .catch(e => { console.log(e) })
        },
       
        // editItem (item) {
        //     this.editedItem = item
        //     this.dialog = true
        // },
        deleteItem (item) {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/EnlaceUsuario/Delete?idEnlaceUsuario=' + item.idEnlaceUsuario)
                .then(s => {
                    me.$root.Mensaje(s.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                    me.GetEnlaceUsuario()
                })
                .catch(e => {                     
                    this.$root.Mensaje(e)
                })
         },
        saveItem () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            var editItem = {
                "idGrupo": me.editedItem.idGrupo,
                "idUsuario": me.editedItem.idUsuario,
                "idEnlace": me.editedItem.idEnlace
            }
            me.$axios.post('api/EnlaceUsuario/Save', editItem)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Enlace asignado a grupo')
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.GetEnlaceUsuario()
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => { 
                    console.log(e)
                    this.$root.Mensaje(e)
                })
        },
    }
}
</script>
